import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core';
import { colors } from '../../../theme/color-palette';
import TextWithDefinition from '../../TextWithDefinition';
const { DARK_GREY, LIGHT_GRAY_HEX } = colors;

const useStyles = makeStyles(() => ({
	noData: {
		height: 'inherit',
		textAlign: 'center',
		border: 'none',
		boxShadow: 'none',
		paddingBottom: '16px',
		margin: '16px',
	},
	noDataAvailable: {
		fontFamily: 'Bogle-Regular',
		fontSize: '16px',
		fontWeight: 700,
		lineHeight: '24px',
		marginBottom: '1%',
	},
	noDataMsg: {
		fontFamily: 'Bogle-Regular',
		fontSize: '14px',
		lineHeight: '24px',
		color: LIGHT_GRAY_HEX,
	},
	errorTableContainer: {
		marginTop: '8%',
	},
	errorContainer: {
		marginTop: '18%',
	},
}));

const errMessage = {
	0: 'Data cannot be loaded at this moment',
	1: 'Data cannot be loaded at this moment',
	2: 'Select atleast one store channel heirarchy level to get the data',
};

const ErrorScreen = (props) => {
	const { chartTitle, isTable, flag, definitionId, hasDefinition } = props;

	const classes = useStyles();

	return (
		<Box className={classes.noData}>
			<TextWithDefinition
				styles={{ fontSize: '18px', color: DARK_GREY }}
				text={chartTitle}
				definitionId={definitionId}
				hasDefinition={hasDefinition}
			/>

			<Box
				className={
					isTable ? classes.errorTableContainer : classes.errorContainer
				}>
				<Typography className={classes.noDataAvailable}>
					No data available
				</Typography>
				<Typography className={classes.noDataMsg}>
					{errMessage[flag]}
				</Typography>
			</Box>
		</Box>
	);
};

ErrorScreen.defaultProps = {
	chartTitle: '',
	isTable: false,
	flag: 0,
};

ErrorScreen.propTypes = {
	chartTitle: PropTypes.string,
	isTable: PropTypes.bool,
	flag: PropTypes.number,
	definitionId: PropTypes.string,
	hasDefinition: PropTypes.bool,
};

export default ErrorScreen;
